import { useState } from "react";
import { loginAdmin } from "../services/auth.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Mail, Lock } from "lucide-react"; // or any icon lib

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    const data = await loginAdmin(email, password);
    console.log("login response", data);
    if (data?.accessToken) {
      toast.success("✅ Login success");
      navigate("dashboard"); // hoặc navigate()
    } else {
      toast.error("❌ Login failed");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white rounded-2xl shadow-lg p-6 space-y-6">
        <h2 className="text-center text-2xl font-semibold text-gray-800">
          Admin Login
        </h2>

        <div className="relative">
          <Mail className="absolute left-3 top-3.5 text-gray-400 w-5 h-5" />
          <input
            type="email"
            placeholder="Email"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="relative">
          <Lock className="absolute left-3 top-3.5 text-gray-400 w-5 h-5" />
          <input
            type="password"
            placeholder="Password"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button
          onClick={handleLogin}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded-lg transition duration-150"
        >
          Login
        </button>
      </div>
    </div>
  );
}
